import axios from "axios";
import environment from "../environment";
import { handleError } from "./error.service";
import { languagesIds } from "../constants/enums";
import { getDeviceId } from "../helpers/getDeviceId";
import { getSessionId } from "../helpers/getSessionId";
import { v4 as uuidv4 } from "uuid";

const lang = languagesIds?.[localStorage.getItem(environment.lang)] || languagesIds.ar;
const DeviceId = localStorage.getItem("deviceId") || getDeviceId();
const SessionId = localStorage.getItem("sessionId") || getSessionId();
const getConfig = (isToken = false) => {
  if (isToken)
    return {
      headers: {
        Tenant: null,
        "Lang-Id": lang,
        "Device-Id": DeviceId,
        "Session-Id": SessionId,
        "Time-Zone-Offset": new Date().getTimezoneOffset() * 60 * -1,
        Authorization: `Bearer ${typeof isToken === "boolean"
          ? localStorage.getItem(environment.TOKEN_KEY)
          : isToken
          }`,
      },
    };
  else
    return {
      headers: {
        Tenant: null,
        "Lang-Id": lang,
        "Device-Id": DeviceId,
        "Session-Id": SessionId,
        "Time-Zone-Offset": new Date().getTimezoneOffset() * 60 * -1,
      },
    };
};

const getPostFormConfig = (isToken) => {
  if (isToken)
    return {
      headers: {
        Tenant: null,
        "Lang-Id": lang,
        "Device-Id": uuidv4(),
        "Session-Id": uuidv4(),
        "Time-Zone-Offset": new Date().getTimezoneOffset() * 60,
        Authorization: `Bearer ${typeof isToken === "boolean"
          ? localStorage.getItem(environment.TOKEN_KEY)
          : isToken
          }`,
        "Content-Type": "multipart/form-data",
      },
    };
  else
    return {
      headers: {
        Tenant: null,
        "Lang-Id": lang,
        "Device-Id": uuidv4(),
        "Session-Id": uuidv4(),
        "Time-Zone-Offset": new Date().getTimezoneOffset() * 60,
        "Content-Type": "multipart/form-data",
      },
    };
};

export const GET = async (apiPath, isToken = false) => {
  let res = {};
  await axios
    .get(`${environment.API_URL}/${apiPath}`, getConfig(isToken))
    .then((response) => {
      res.status = response.status;
      res.data = response.data;
    })
    .catch((error) => {
      handleError(error?.response);
    });
  return res;
};

export const POST = async (apiPath, requestBody, isToken = false) => {
  let res = {};

  await axios
    .post(`${environment.API_URL}/${apiPath}`, requestBody, getConfig(isToken))
    .then((response) => {
      res.status = response.status;
      res.data = response.data;
    })
    .catch((error) => {
      handleError(error?.response);
    });
  return res;
};

export const PUT = async (apiPath, requestBody, isToken = false) => {
  let res = {};

  await axios
    .put(`${environment.API_URL}/${apiPath}`, requestBody, getConfig(isToken))
    .then((response) => {
      res.status = response.status;
      res.data = response.data;
    })
    .catch((error) => {
      handleError(error?.response);
    });
  return res;
};

export const CustomPost = async (apiPath, requestBody) => {
  let res = {};
  await axios
    .post(`${environment.API_URL}/${apiPath}`, requestBody, getConfig())
    .then((response) => {
      res.status = response.status;
      res.data = response.data;
    })
    .catch((error) => {
      res.status = error?.response?.status;
    });
  return res;
};
export const POSTForm = async (apiPath, requestBody) => {
  let res = {};

  await axios
    .post(`${environment.API_URL}/${apiPath}`, requestBody, getPostFormConfig())
    .then((response) => {
      res.status = response.status;
      res.data = response.data;
    })
    .catch((error) => {
      handleError(error?.response);
    });
  return res;
};
export const PUTForm = async (apiPath, requestBody) => {
  let res = {};

  await axios
    .put(`${environment.API_URL}/${apiPath}`, requestBody, getPostFormConfig())
    .then((response) => {
      res.status = response.status;
      res.data = response.data;
    })
    .catch((error) => {
      handleError(error?.response);
    });
  return res;
};
